export interface ConditionsTree {
  nodeType: NodeType;
  leftSon: ConditionsTree;
  rightSon: ConditionsTree;
  funcName: string;
  funcArgs: ConditionArgs;
  nodeDepth: number;
  ConditionId: string;
  lastUpdateTime: number;
}

export enum NodeType {
  And,
  Or,
  Func,
}

export type ConditionArgs = {
  conditionBlockId: number;
};
